const edu = [
  {
    id: "one",
    date: "11/2023 - To Present",
    institution: "Coursera",
    subject: "Google Cybersecurity",
  },
  {
    id: "two",
    date: "09/2022 - To Present",
    institution: "Code Your Future (CYF)",
    subject: "Software Development Course",
    details: [
      "Learnt different programming languages, frameworks and libraries to build personal and team projects.",
      "In my 1st team project, managed the team in the role of Project Manager as well as a front developer. I was responsible for drawing out project delivery plans and prototype designs to make sure the team is on track and there is a clear path regarding the MVP.",
      "As Project Manager, drew out a project delivery plan and prototype designs using Excel and Figma respectively",
      "Managed workflows, reviewed code to prevent merge conflicts and eliminate bugs.",
      "Shadowed a CYF product owner to learn more about the role as part of a Product Management Pathway. Within that time, I identified a gap within the organization for which I conceived and presented a product concept to address the solution.",
      "Organized and co-hosted an International Women’s Day event to connect industry professionals to fellow trainees.",
      "Coordinated catch up sessions to help fellow trainees’ complete outstanding work and create a space where we can knowledge share.",
      "During my final project, worked as part of a team of 4 to create a website that ensured fair contribution of team members in the final project. I was also the designated point of contact for addressing technical issues ranging from merge conflicts to blockers.",
    ],
  },
  {
    id: "three",
    date: "09/2010 - 06/2013",
    institution: "London South Bank University",
    subject: "BSc (Hons) Forensic Science",
  },
];

export default edu;
